import { Message } from "@JohnLewisPartnership/jl-design-system/dist/components/message/Message";
import { Energy } from "@~/types/prodcatBaseTypes";
import styles from "../EnergyRating.module.scss";
import { modifyImageUrlQueryParams } from "@JohnLewisPartnership/jl-design-system/dist/utils/imageUrlModifier/imageUrlModifier";

type Props = {
  energy: Energy;
  altText?: string;
};

export function EnergyImage({ energy, altText }: Props) {
  if (energy.label) {
    return (
      <img
        className={styles.energyImg}
        src={modifyImageUrlQueryParams(energy.label)}
        alt={altText}
      />
    );
  }

  if (altText) {
    return (
      <Message
        type="information"
        dataTestId="energy-drawer-message"
        body={altText}
      />
    );
  }

  return null;
}
